import script from "./MenuSupMainV2.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSupMainV2.vue?vue&type=script&setup=true&lang=js"

import "./MenuSupMainV2.vue?vue&type=style&index=0&id=73188a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73188a4c"]])

export default __exports__